<div class="text-center" *ngIf="loading">
  <i class="fas fa-spinner fa-pulse fa-3x"></i>
</div>
<div *ngIf="!loading">
  <div class="row mt-3">
    <div class="col-md-10 ml-md-auto mr-md-auto">
      <div class="row">
        <div class="col-md-4 text-center ml-md-auto">
          <pagination
            class="pagination-sm"
            (pageChanged)="loadInvoices($event)"
            [boundaryLinks]="true"
            [totalItems]="count"
            [maxSize]="5"
            [(ngModel)]="search_params.page"
            [itemsPerPage]="search_params.per_page"
            previousText="&lsaquo;"
            nextText="&rsaquo;"
            firstText="&laquo;"
            lastText="&raquo;"
          ></pagination>
        </div>
      </div>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped table-sm">
      <thead>
        <tr>
          <th>ID</th>
          <th>Date</th>
          <th>Document</th>
          <th class="text-right">Amount</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let invoice of invoices" [class.table-success]="invoice.is_paid" [class.table-secondary]="invoice.is_deleted">
          <td><a [href]="'/invoices/' + invoice.id" target="_blank">{{ invoice.id }}</a></td>
          <td>{{ invoice.created_at }}</td>
          <td>
            <a [href]="authService.getAuthenticatedDownloadUrl('/documents/' + invoice.document_id + '/download')" target="_blank">
              <img *ngIf="invoice.document_image" [src]="invoice.document_image" style="height: 20px;" />
              {{ invoice.document_name }}
            </a>
          </td>
          <td class="text-right">{{ invoice.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
          <td>
            <span *ngIf="invoice.is_paid" class="badge badge-success">Paid</span>
            <span *ngIf="invoice.is_deleted" class="badge badge-secondary">Withdrawn</span>
            <span *ngIf="!invoice.is_paid && !invoice.is_deleted" class="badge badge-warning">Pending</span>
          </td>
          <td>
            <div class="btn-group btn-group-sm" *ngIf="!invoice.is_deleted">
              <button type="button"
                      class="btn btn-outline-success btn-sm"
                      (click)="markPaid(invoice)"
                      [disabled]="invoice.is_paid || invoice.actionInProgress"
                      title="Mark as Paid">
                <i class="fas fa-check"></i>
              </button>
              <button type="button"
                      class="btn btn-outline-danger btn-sm"
                      (click)="withdrawInvoice(invoice)"
                      [disabled]="invoice.actionInProgress"
                      title="Withdraw Invoice">
                <i class="fas fa-undo"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
